import { useQuery } from '@tanstack/react-query';
import { graphQLClient } from 'graphql/graphQLClient';
import { toReportEndDate, toReportStartDate } from 'utils/reportSalesUtils';
import {
  getReportSalesErrorMessage,
  REPORT_SALES_TOTALS_QUERY,
  ReportSalesTotals,
  ReportSalesTotalsResponse,
} from './useReportSales';

export type { ReportSalesTotals };

export interface ReportSalesTotalsQueryParams {
  startDate: string;
  endDate: string;
}

export const REPORT_SALES_TOTALS_QUERY_KEY = 'reportSalesTotals';

export async function fetchReportSalesTotals({
  startDate,
  endDate,
}: ReportSalesTotalsQueryParams) {
  const result = await graphQLClient.request<ReportSalesTotalsResponse>({
    query: REPORT_SALES_TOTALS_QUERY,
    variables: {
      startDate: toReportStartDate(startDate),
      endDate: toReportEndDate(endDate),
    },
  });

  const errorMessage = getReportSalesErrorMessage(result);

  if (errorMessage) {
    throw new Error(errorMessage);
  }

  if (!result.data?.reportSalesTotals) {
    throw new Error('No se recibieron totales del reporte de ventas');
  }

  return result.data.reportSalesTotals;
}

export function useReportSalesTotals(params: ReportSalesTotalsQueryParams | null) {
  return useQuery({
    queryKey: [REPORT_SALES_TOTALS_QUERY_KEY, params?.startDate, params?.endDate],
    queryFn: () => fetchReportSalesTotals(params!),
    enabled: Boolean(params?.startDate && params?.endDate),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
